import { HALApiService } from '../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const userRolesService = new CachedService(entities.Orderadmin_Users_Entity_Role, '/users/roles', HALApiService, createItemsData)
